interface LoadingScreenProps {
  message: string
}

export function LoadingScreen ({ message }: LoadingScreenProps) {
  return (
    <div className="h-full w-full bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#8B0000] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-500">
          {message}
        </p>
      </div>
    </div>
  )
}
